export const toTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
export const formatIntegerCentAmount = (amount: number) => {
    let displayAmount = (amount / 100);
    if (amount % 100 === 0) {
        return displayAmount;
    }

    return (amount / 100).toFixed(2);
}